import { ComponentMutation } from "../types";
import { Session } from "@/framework/types/Session";

export default {
  [ComponentMutation.SET_NAVIGATION](state: any, payload: any) {
    state.navigation = payload;
  },
  [ComponentMutation.SET_NAVIGATION_UPDATE](state: any, payload: any) {
    state.navigationUpdate = payload;
  },
  [ComponentMutation.SET_APP_MODE](state: any, payload: any) {
    state.appMode = payload;
  },
  [ComponentMutation.SET_IS_ENABLE_KTZN_LANG](state: any, payload: boolean) {
    state.isEnableKtznLang = payload;
  },
  [ComponentMutation.SET_BOTTOM_NAVIGATION](state: any, payload: any) {
    state.bottomNavigation = payload;
  },
  [ComponentMutation.SET_IS_WECHAT](state: any, payload: boolean) {
    state.isWeChat = payload;
  },
  [ComponentMutation.SET_IS_LOADING](state: any, payload: boolean) {
    state.isLoading = payload;
  },
  [ComponentMutation.SET_IS_SAVING](state: any, payload: boolean) {
    state.isSaving = payload;
  },
  [ComponentMutation.SET_INITIAL_LOADING](state: any, payload: boolean) {
    state.initialLoading = payload;
  },
  [ComponentMutation.SET_CLOSE_PRIVACY_POLICY_FOOTER](state: any, payload: any) {
    state.closePrivacyPolicyFooter = payload;
  },
  [ComponentMutation.SET_IS_RE_CONNECTINT_NOW](state: any, payload: any) {
    state.isReConnectingNow = payload;
  },
  [ComponentMutation.SET_SESSION](state: any, payload: Session) {
    state.session = payload;
  },
  [ComponentMutation.ADD_EVENT_ID](state: any, payload: Session) {
    state.recievedEventIdList.push(payload);
  },
  [ComponentMutation.SET_IS_FROM_LOGIN](state: any, payload: Session) {
    state.isFromLogin = payload;
  },
  [ComponentMutation.SET_IS_REDIRECTED](state: any, payload: Session) {
    state.isRedirected = payload;
  },
  [ComponentMutation.SET_CHECK_NOTIFICATION_PERMISSION](state: any, payload: boolean) {
    state.checkNotificationPermission = payload;
  },
  [ComponentMutation.GUEST_HIDE_HOME_ICON](state: any, payload: boolean) {
    state.guestHideHomeIcon = payload;
  },
};
